module.exports = __webpack_public_path__ + "img/side_tg.f19d6857.png";